/*eslint no-new: 0*/

import 'consumerweb-shim';
import $ from 'jquery';
import { requirejs } from 'requirejs';
// import error from 'components/consumerweb-client-error-logger/error';
import Router from 'router';
import Analytics from 'widgets/analytics';
import HeaderView from 'view/header';
// import konami from 'konami';
import FastClick from 'fastclick';
import neff from 'neff';
import SessionTimer from 'widgets/sessionTimer';
import 'widgets/ajaxError';
import 'lib/bb-errors';
import 'lib/auto-submit';
import 'lib/rlogid';
import Backbone from 'backbone';
import prefetches from 'lib/prefetch-manager';
Backbone.sync = prefetches(Backbone.sync);

/**
 * Bootstrap the app
 */
let $body = $('body'),
	csrf = $body.data('token');

// awesome speed improvements on mobile
FastClick.attach(document.body);

// Adding CSRF token for all AJAX calls
$.ajaxPrefilter(function(opts, origOpts, jqXHR) {
	jqXHR.setRequestHeader('X-CSRF-Token', csrf);
});

// Fetch all templates (non-blocking) and prime them in dust.cache
if (neff.isEnabled('bundle')) {
	let templatePath = $body.data('templatePath').replace('%s', 'dust-templates');
	let languagePack = templatePath.replace('templates', 'locales').replace('dust-templates', 'languagepack');
	requirejs([templatePath, languagePack]);
}

// start capturing global errors first thing
// error.start('/myaccount/error');

// Analytics used for tracking links and errors
if (neff.isEnabled('analytics')) {
	Analytics.initialize();
}

// start counting the session
new SessionTimer({
	extendSessionUrl: '/myaccount/extendSession'
});

// setup the header view
new HeaderView();

// and start the router to really get things going..
new Router();



// WEBPACK FOOTER //
// ./app.es6